import API from './../api';
import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';

export default {
    namespaced: true,

    state() {
        return {
            enable: false,
            enableOnline: false,
            enableGuestApp: false,
            useDefaultEmail: true,
            notificationEmail: null,
            enableGuestViewNotification: false,
            enableGuestSignNotification: false,
            isDigitalSignatureSettingsLoading: false,
        };
    },

    getters: {
        enable: state => state.enable,
        enableOnline: state => state.enableOnline,
        enableGuestApp: state => state.enableGuestApp,
        useDefaultEmail: state => state.useDefaultEmail,
        notificationEmail: state => state.notificationEmail || '',
        enableGuestViewNotification: state => state.enableGuestViewNotification,
        enableGuestSignNotification: state => state.enableGuestSignNotification,
        isDigitalSignatureSettingsLoading: state => state.isDigitalSignatureSettingsLoading,
    },

    mutations: {
        onFetch(state, response) {
            if (response.data) {
                Object.keys(response.data).forEach(key => {
                    const camelCaseKey = camelCase(key);
                    if (state.hasOwnProperty(camelCaseKey)) {
                        state[camelCaseKey] = response.data[key];
                    }
                });
            }
        },
        setValue(state, { key, value }) {
            state[key] = value;
        },
        setDigitalSignatureSettingsLoading(state, isLoading){
            state.isDigitalSignatureSettingsLoading = isLoading;
        },
    },

    actions: {
        async fetch({ commit }) {
            commit('setDigitalSignatureSettingsLoading', true)
            commit('onFetch', await API.get('/app/digital-signature/setting/'));
            commit('setDigitalSignatureSettingsLoading', false)
        },
        set({ commit }, { key, value }) {
            commit('setValue', { key, value });
        },
        async save({ commit }, { key, value }) {
            const payload = {};
            payload[snakeCase(key)] = value;
            await API.post('/app/digital-signature/setting/', payload);
            commit('setValue', { key, value });
        },
    },
};
